import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useAppContext } from '../../contexts/AppContext';
import { useMemo, useRef, useState } from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { asNamedSolutions, type ScreenSolution } from '../../types';
import { buildFinancialComparisonOptions } from '../../utils/chartOptions/financialComparison';

type Props = {
  data: ScreenSolution[];
};

const FinancialComparison = ({ data }: Props) => {
  const { isDarkMode } = useAppContext();
  const chartComponent = useRef(null);
  const [isLoading] = useState(false);
  const chartOptions = useMemo(() => buildFinancialComparisonOptions(asNamedSolutions(data)), [data]);

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {isLoading ? (
          <Backdrop open={true} sx={{ width: '100%', height: '450px', position: 'relative' }}>
            <CircularProgress />
          </Backdrop>
        ) : (
          data &&
          chartOptions && (
            <>
              <HighchartsReact
                ref={chartComponent}
                containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
                highcharts={Highcharts}
                options={chartOptions}
              />
            </>
          )
        )}
      </Box>
    </>
  );
};

export default FinancialComparison;
